import React from 'react';
import { connect } from 'react-redux';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import HelpIcon from '@material-ui/icons/Help';
import FormHelperText from '@material-ui/core/FormHelperText';

import {
  ExpansionPanelWrapperHourly,
  FormActionButtons,
  CurrencyInputWrapper,
  PopoverWrapper,
  TimePicker
} from 'components';

import { useStyles } from './styles';
import validate from './validate';
import uuid from 'uuid/v1';

const PRICES_PER_DAY = {
  USD: '0',
  EUR: '0',
  NOK: '0'
};

const initialValues = {
  hourlyList: [
    {
      id: uuid(),
      time: 'Master Price',
      startTime: null,
      isMaster: true,
      minHours: '1',
      maxHours: '24',
      ...PRICES_PER_DAY
    }
  ]
};

const PricesHourly = ({ handleSubmit, setSubmitButton, isUpdate, hourlyList }) => {
  const classes = useStyles();
  const [t] = useTranslation();

 
  const onAddHandler = (fields) => {
    fields.push({
      id: uuid(),
      time: '',
      startTime: moment().startOf('hour'),
      isMaster: false,
      minHours: '',
      maxHours: '',
      ...PRICES_PER_DAY
    });
  };

  const onRemoveHandler = (item, fields, index) => {
    if (item?.isMaster === true) {
      return; 
    }
    fields.remove(index);
  };

  const onRemoveAllHandler = (fields) => {
    const master = fields.getAll()?.find(item => item?.isMaster === true);
    fields.removeAll();
    if (master) {
      fields.push(master);
    }
  };

  const getTitle = (fieldObj) => {
    if (fieldObj?.isMaster === true) {
      return 'Master Price';
    }

    if (fieldObj?.startTime) {
      const formatted = moment(fieldObj.startTime).format('HH:mm');
      return `${formatted}`;
    }

    return 'Price Entry';
  };

 const renderPriceItem = (field, index, meta, list) => {
  const item = list[index] || {};
  const isMaster = item.isMaster === true;

  return (
    <div className={classes.prices}>
      <Field
        name={`${field}.isMaster`}
        component="input"
        type="hidden"
      />
      <Field
        name={`${field}.time`}
        component="input"
        type="hidden"
      />
      
      {!isMaster && (
        <div className={classes.timeSection}>
          <Field
            name={`${field}.startTime`}
            component={TimePicker}
            label="Start Time"
            className={classes.timePicker}
          />
        </div>
      )}

      <div className={classes.row}>
        <Field
          name={`${field}.NOK`}
          label="NOK"
          isHiddenErrorMsg={true}
          className={classes.currencyField}
          component={CurrencyInputWrapper}
        />
        <Field
          name={`${field}.EUR`}
          label="EUR"
          isHiddenErrorMsg={true}
          className={classes.currencyField}
          component={CurrencyInputWrapper}
        />
        <Field
          name={`${field}.USD`}
          label="USD"
          isHiddenErrorMsg={true}
          className={classes.currencyField}
          component={CurrencyInputWrapper}
        />
        <PopoverWrapper text="Value for at least one currency should be filled in. Currencies marked with zero (or empty) will not be displayed on the widget.">
          <HelpIcon className={classes.helpIcon} />
        </PopoverWrapper>
      </div>

      {isMaster && (
        <div className={classes.hoursSection}>
           <div>
            <Field
              name={`${field}.minHours`}
              type="number"
              label= "Min Hour"
              min="1"
              max="24"
              component={CurrencyInputWrapper}
              className={classes.currencyField}
            />
          </div>
          <div>
          
            <Field
              name={`${field}.maxHours`}
              type="number"
              label= "Max Hour"
              min="1"
              max="24"
             component={CurrencyInputWrapper}
             className={classes.currencyField}
            />
          </div>
          <PopoverWrapper text="Minimum and maximum hours for booking. Min must be less than or equal to Max.">
            <HelpIcon className={classes.helpIcon} />
          </PopoverWrapper>
        </div>
      )}

      {meta.submitFailed && meta.error && meta.error[index] && (
        <FormHelperText error>{t(meta.error[index])}</FormHelperText>
      )}
    </div>
  );
};

  const renderPriceItemWithValues = (field, index, meta) => {
    return renderPriceItem(field, index, meta, hourlyList);
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <FieldArray
          name="hourlyList"
          component={ExpansionPanelWrapperHourly}
          isAddDeleteActions={true}
          add={onAddHandler}
          remove={onRemoveHandler} 
          removeAll={onRemoveAllHandler}
          getTitle={getTitle}
          tabName="hourly price entry"
          tabNameAll="all hourly price entries"
          deleteDescription={t('This will permanently delete the hourly price entry.')}
          children={renderPriceItemWithValues}
        />
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

const mapStateToProps = (state) => {
  const form = state.form.pricesHourlyForm || {};
  return {
    pricesHourlyForm: form,
    hourlyList: form.values?.hourlyList || []
  };
};

export default reduxForm({
  form: 'pricesHourlyForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  validate,
  initialValues,
})(connect(mapStateToProps, null)(PricesHourly));